// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"62e454cf","259":"52e4d2ec","364":"9dd477bb","488":"4d09e890","490":"988e9163","516":"8d36d717","554":"73a6f6d7","598":"220e3ac0","746":"a79575a8","756":"4851cf5d","759":"64e34971","787":"88381667","841":"1b2385e1","850":"130165fe","954":"8125ee8b","984":"412fe5bb"}[chunkId] + ".chunk.js";
};